import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'header-system-datetime',
  templateUrl: './header-system-datetime.component.html',
  styleUrls: ['./header-system-datetime.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, MatTooltipModule],
})
export class HeaderSystemDatetimeComponent implements OnInit, OnDestroy {
  now = new Date();

  private _intervalId: ReturnType<typeof setInterval> | null = null;

  constructor(private _cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    this._intervalId = setInterval(() => {
      this.now = new Date();
      this._cdr.markForCheck();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this._intervalId !== null) {
      clearInterval(this._intervalId);
    }
  }
}
